import * as React from 'react';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export interface ButtonBaseTileProps extends React.HTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  toggled?: boolean;
  fullWidth?: boolean;
}

enum ButtonBaseTileColors {
  PRIMARY = '#427bff',
  SECONDARY = '#FFFFFF',
}

const StyledButtonTile = styled('button')<ButtonBaseTileProps>`
  background-color: ${({ toggled }) =>
    toggled ? ButtonBaseTileColors.SECONDARY : ButtonBaseTileColors.PRIMARY};
  color: ${({ toggled }) =>
    toggled ? ButtonBaseTileColors.PRIMARY : ButtonBaseTileColors.SECONDARY};
  border-radius: 6px;
  padding: ${themeGet('space.3')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  appearance: none;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-content: stretch;
  margin: 0;
  border: 0;
  line-height: 1;
  user-select: none;
  text-decoration: none;
  text-align: center;
  font-family: ${themeGet('fontFamily.sans-serif')};
  font-weight: ${themeGet('fontWeights.bold')};
  transition-property: background, border, box-shadow, color;
  transition-duration: ${themeGet('transition.transition-duration-fast')};
  cursor: pointer;

  &:hover,
  &:active {
    background-color: ${ButtonBaseTileColors.SECONDARY};
    color: ${ButtonBaseTileColors.PRIMARY};
  }

  &:disabled {
    background-color: ${themeGet('colors.gray-800')};
    color: ${themeGet('colors.gray-600')};
  }
`;

// The generic might looks like it's inverted but it's not.
// React.forwardRef is a generic function that is declared <T, P> as <T> for ref and <P> for props.
// while it's the opposite ordering for the function parameters declared as <P, T>
const ButtonBaseTile = React.forwardRef<HTMLButtonElement, ButtonBaseTileProps>((props, ref) => {
  return (
    <StyledButtonTile ref={ref} {...props}>
      {props.children}
    </StyledButtonTile>
  );
});

export { ButtonBaseTile };
